import React from "react";
import "../../css/designSystem/TestimonialCard.css";
import { ReactComponent as QuoteIcon } from "../../assets/icons/QuotationMark.svg";

const TestimonialCard = ({ title, content, author }) => {
  return (
    <div className="testimonial-card">
      <QuoteIcon />
      <h3 className="grey align-left">{title}</h3>
      <div className="content grey align-left">{content}</div>
      <div className="content-semibold  burgandy align-left">{author}</div>
    </div>
  );
};

export default TestimonialCard;
